import React from 'react'
import { useSelector } from 'react-redux';

import { Checkbox } from "primereact/checkbox"
import { checkPermissions } from '../utils';
import PermDetailsWrapper from '../common/PermDetailsWrapper';


const CheckboxField = (props) => {
    const userDetails = useSelector(state => state.userDetails)

    const fieldName = props.name ? props.name : "name"
    const inputId = props.inputId ? props.inputId : ""
    const checked = props.checked ? props.checked : false
    const value = props.value ?  props.value  : null
    const labelText = props.label ? props.label : ""
    const tooltip = props.tooltip ? props.tooltip : ""
    const tooltipOptions = props.tooltipOptions ? props.tooltipOptions : {}

    const permissions = props.permissions ? props.permissions : []
    const permParameters = props.permParameters ? props.permParameters : {}

    let disabled = false 
    let isPermitted = false
    let permittedCompanyRoleIds = []
    let permittedExceptionUserRoleIds = []
    let permittedExceptionNegitiveUserRoleIds = []

    if(permissions.length){
        //console.log("permissions input", permissions)
        const permParams = {
            reqPermActionIds: permissions,
            permParameters: permParameters,
            activeCompanyRoleId: userDetails.activeCompanyRoleId,
            userRoleId: userDetails.activeRoleId,
            permExceptions: userDetails.permExceptions,
            permGeo: userDetails.permGeo,
            permActions: userDetails.permActions,
            permRoles: userDetails.permRoles,
            companyRoles: userDetails.companyDetails.companyRoles
        }

        const permissionDetails = checkPermissions(permParams)
        isPermitted = permissionDetails.isPermitted
        permittedCompanyRoleIds = permissionDetails.permittedCompanyRoleIds
        permittedExceptionUserRoleIds = permissionDetails.permittedExceptionUserRoleIds
        permittedExceptionNegitiveUserRoleIds = permissionDetails.permittedExceptionNegitiveUserRoleIds

        if(!isPermitted){
            disabled = true
        }
    }

    if(props.disabled){
        disabled = true
    }

    const searchMethod = props.searchMethod ? props.searchMethod : null

    const handleOnchange = (event) => {
        if (props.onChange) {
            props.onChange(event)
        } 
    }

    const renderCheckboxField = () => (
        <div className="field-checkbox mb-0">
            <Checkbox name={fieldName} inputId={inputId} value={value} disabled={disabled} checked={checked} onChange={handleOnchange} tooltip={tooltip} tooltipOptions={tooltipOptions} />
            { labelText ? <label style={{ fontSize: "13px" }} htmlFor={inputId}>{ labelText }</label> : "" }
        </div>
    )

    return (
        <PermDetailsWrapper
            displayComponent={renderCheckboxField()}
            uniqueId={props.labelText}
            permissions={permissions}
            permittedCompanyRoleIds={permittedCompanyRoleIds}
            permittedExceptionUserRoleIds={permittedExceptionUserRoleIds}
            permittedExceptionNegitiveUserRoleIds={permittedExceptionNegitiveUserRoleIds}
            visible={!props.disabled && !isPermitted}
        />
    )
}

export default CheckboxField;